/* @flow */
import * as React from 'react';
import Checkbox from 'components/Checkbox';
import { withTranslation } from 'react-i18next';
import styles from './styles.module.scss';

import type { Translate } from 'types';

type Props = {
  isSelectable: boolean,
  isSelected: boolean,
  onCheckboxClick?: () => mixed,
  actionButtons?: React.Node,
  t: Translate,
};

type State = {};

class LicenseComponentListHeader extends React.PureComponent<Props, State> {
  state = {};

  render() {
    const {
      isSelectable = true,
      isSelected = false,
      onCheckboxClick,
      actionButtons,
      t,
    } = this.props;

    return (
      <div className={styles.row}>
        {isSelectable && (
          <div className={styles.checkbox}>
            <Checkbox onClick={onCheckboxClick} small={true} checked={isSelected} />
          </div>
        )}
        <div className={styles.description}>{t('DESCRIPTION')}</div>
        <div className={styles.price}>{t('PRICE')}</div>
        <div className={styles.discountedPrice}>{t('DISCOUNTED_PRICE')}</div>
        <div className={styles.actionButtons}>{actionButtons}</div>
      </div>
    );
  }
}

export default withTranslation()(LicenseComponentListHeader);
